<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :refresh.sync="refreshTable"
            ajax-path="admin/permissions"
        />
        <app-modal
            :show.sync="showEditModal"
            width="md:w-1/2 lg:w-1/4"
            @close="editModalClosed"
        >
            <template slot="header">Edit Permission</template>
            <template slot="body">                
                <app-input
                    v-model="editForm.name"
                    placeholder="Name"
                    :error="editForm.errors.get('name')"
                    @updated="editForm.errors.clear('name')"
                    focus
                    required
                />                             
                <div class="mt-5 flex items-center justify-end">
                    <app-button 
                        class="btn-white" 
                        @click="showEditModal = false"
                        :disable="editFormIsLoading"
                    >Cancel</app-button>
                    <app-button 
                        class="btn-blue ml-3" 
                        @click="update"
                        :loading="editFormIsLoading"
                    >Save</app-button>
                </div>
            </template>
        </app-modal>
        <app-modal
            :show.sync="showAddModal"
            width="md:w-1/2 lg:w-1/4"
            @close="addModalClosed"
        >
            <template slot="header">Add Permission</template>
            <template slot="body">
                <div>
                    <app-input
                        v-model="addForm.name"
                        placeholder="Name"
                        :error="addForm.errors.get('name')"
                        @updated="addForm.errors.clear('name')"
                        focus
                        required
                    />                    
                    <div class="mt-5 flex items-center justify-end">
                        <app-button 
                            class="btn-white" 
                            @click="showAddModal = false"
                            :disable="addFormIsLoading"
                        >Cancel</app-button>
                        <app-button 
                            class="btn-blue ml-3" 
                            @click="store"
                            :loading="addFormIsLoading"
                        >Add</app-button>
                    </div>
                </div>
            </template>
        </app-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Form from '@/helpers/Form';

    export default {
        data() {
            return {
                addForm: new Form({
                    name: null,
                }),
                editForm: new Form({
                    id: null,
                    name: null,
                }),
                editFormIsLoading: false,
                addFormIsLoading: false,
                tableIsLoading: false,
                showEditModal: false,
                showAddModal: false,
                refreshTable: false,
                columns: [
                    {
                        title: 'Name', 
                        field: 'name', 
                        sorter: 'string',
                        minWidth: 150,
                    }
                ],
                actions: [
                    {
                        label: 'Edit',
                        icon: () => import('@/icons/EditOutlined.vue'),
                        handler: permissions => {
                            this.showEditModal = true;
                            this.editForm.set(permissions[0]);
                        },
                        requiredSelect: true,
                    },
                    {
                        label: 'Delete',
                        icon: () => import('@/icons/DeleteOutlined.vue'),
                        handler: permissions => {
                            this.deletePermission(permissions[0]);
                        },
                        requiredSelect: true,
                    },
                    {
                        label: 'Refresh',
                        icon: () => import('@/icons/Refresh.vue'),
                        handler: this.getPermissions,
                    },
                    {
                        label: 'Add',
                        icon: () => import('@/icons/Add.vue'),
                        handler: this.add,
                    }
                ],
            }
        },
        methods: {
            edit(item) {
                this.showEditModal = true;
                this.editForm.set(item);
            },
            editModalClosed() {
                this.editForm.reset();
                this.editForm.errors.clear();                
            },
            update() {
                this.editFormIsLoading = true;
                this.$store.dispatch('admin/permissions/update', this.editForm.payload())
                    .then(() => {
                        this.editFormIsLoading = false;
                        this.showEditModal = false;
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Permission was updated successfully.'
                        })
                    })
                    .catch(({ response }) => {
                        this.editFormIsLoading = false;
                        this.editForm.errors.record(response.data);
                    });
            },
            addModalClosed() {
                this.addForm.reset();
                this.addForm.errors.clear();
            },
            add() {
                this.showAddModal = true;
            },
            store() {
                this.addFormIsLoading = true;
                this.$store.dispatch('admin/permissions/store', this.addForm.payload())
                    .then(() => {
                        this.addFormIsLoading = false;
                        this.showAddModal = false;
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Permission was added successfully.'
                        })
                    })
                    .catch(({ response }) => {
                        this.addFormIsLoading = false;
                        this.addForm.errors.record(response.data);
                    })
            },
            deletePermission(item) {
                this.$swal.fire({
                    type: 'warning',
                    title: 'Are you sure?',
                    html: `You are about to delete "<strong>${item.name}</strong>" permission permanently.`,
                    showCancelButton: true,
                    confirmButtonColor: '#f56565',
                    confirmButtonText: 'Yes, delete it!',
                    showLoaderOnConfirm: true,
                    preConfirm: (response) => {
                        return this.$store.dispatch('admin/permissions/delete', item.id);
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                })
                .then((result) => {
                    if (result.value) {
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Permission was successfully deleted.'
                        })
                    }
                })
                
            }
        }
    }
</script>